import React, {useContext, useEffect} from 'react';
import "./c83_banner_with_image.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {Context} from "../../hooks/Store";
import {isMobileOnly} from "react-device-detect";

const Banner = (props) => {
    const [state, dispatch] = useContext(Context); // eslint-disable-line

    useEffect(() => {
        isMobileOnly && dispatch({type: 'c83BannerData', payload: props.data});
    }, []); // eslint-disable-line

    return <div id="bannerWithImage">
        {!isMobileOnly ? <div className="card">
            <div className="img-container">
                <img className="image-card" src={props.data.image} alt={props.data.title}/>
            </div>
            <div className="card-body">
                <div className="title">{props.data.title}</div>
                <div className="subtitle">{props.data.subtitle}</div>
                <a href={props.data.link}>
                    <div className="card-link">{props.data.link_label}</div>
                    <span className="arrow">&#8594;</span> </a>
            </div>
        </div> : null}
    </div>;
}

class C83BannerWithImage extends TemplateComponent {
    componentRender(data) {
        return (
            <Banner data={data}/>
        );
    };
}

export default C83BannerWithImage;
